<template>
  <div class="stock-offers" id="stock-offer">
    <h2 class="stock-offers__head px-3 px-md-4 py-3">
      {{ i18n.stock_offers_heading }}
    </h2>

    <div class="p-3 p-md-4">
      <usps
        class="stock-offers__usps"
        :usps="responseOptions.stockUsps"
      />

      <stock-offer-item
        v-for="offer in responseStockOffers"
        :key="offer.id"
        :offer-item="offer"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from './Icon';
import StockOfferItem from './StockOfferItem';
import Usps from './Usps';

export default {
  components: {
    Usps,
    StockOfferItem,
    Icon,
  },

  computed: {
    ...mapGetters([
      'responseStockOffers',
      'responseOptions',
      'formInput',
    ]),
  },
};
</script>

<style scoped>
.stock-offers {
  background-color: #fff;
}

.stock-offers__head {
  background-color: #231f20;
  color: #fff;
  font-size: 1.25rem;
  margin-bottom: 0;
}

.stock-offers__usps {
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .stock-offers__usps {
    margin-bottom: 1.5rem;
  }
}

@media (min-width: 1200px) {
  .stock-offers__usps {
    display: flex;
  }

  .stock-offers__usps :global(li) {
    margin-right: 1.5rem;
  }
}
</style>
